<mg-splash></mg-splash>
<router-outlet></router-outlet>
